import { Box } from "@mui/material";
import TextFieldControl from "components/form/TextFieldControl";
import palette from "theme/palette";
import SectionLabel from "./SectionLabel";

interface PromptSectionProps {
  name: "comment" | "criterionComment";
  title: string;
  placeholder: string;
}

const PromptSection = ({ name, title, placeholder }: PromptSectionProps) => {
  return (
    <Box sx={{ flex: 1 }}>
      <SectionLabel>
        {title}{" "}
        <Box
          component='span'
          sx={{ fontWeight: 400, textTransform: "none", letterSpacing: 0, color: "text.secondary" }}>
          — приоритет над дефолтными
        </Box>
      </SectionLabel>
      <Box
        sx={{
          p: 1,
          borderRadius: 1.5,
          border: `1px solid ${palette.divider}`,
          backgroundColor: "bgSwitch",
        }}>
        <TextFieldControl
          name={name}
          multiline
          minRows={4}
          maxRows={4}
          placeholder={placeholder}
          hideHelperText
          sx={{
            mb: 0,
            "& .MuiOutlinedInput-root": {
              backgroundColor: "transparent",
            },
            "& .MuiInputBase-input": {
              fontSize: 13,
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default PromptSection;
